import { call } from 'redux-saga/effects'
import { loadMeasurements } from './measurements'

function * navigation () {
  yield call(loadMeasurements)
}

export default navigation
